import fr from 'vuetify/lib/locale/fr'

// Libellés applicatifs, accessibles via this.$vuetify.lang.t('$vuetify.<clé>')
export default {
    ...fr,
    timeSlot: {
        AM: 'Matin',
        PM: 'Après-midi',
    },
    login: {
        missingUser: 'Veuillez saisir votre e-mail.',
        badCredentials: 'E-mail ou mot de passe incorrect.',
        serverUnreachable: 'Serveur injoignable. Vérifiez votre connexion internet.',
        serverError: 'La connexion a échoué. Veuillez réessayer plus tard.',
        passwordExpired: 'Votre mot de passe a expiré. Un lien pour en choisir un nouveau vient de vous être envoyé par e-mail.',
        tooManyAttempts: 'Trop de tentatives. Réessayez dans 15 minutes.',
    },
}
